import styled from 'styled-components';
import { treeTogglerCaret } from 'src/common/treeToggler.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin: 0;
    padding: 0;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  overflow-y: auto;
  border-radius: 6px;
  min-width: 550px;
  background-color: ${({ theme }) => theme.colors.cultured};

  .p-treetable-header {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 12px;
  }

  .p-treetable {
    margin: 0;
    padding: 0;

    .p-treetable-wrapper {
      margin: 0;
      padding: 0;
    }

    table {
      margin: 0;
      padding: 0;
    }

    .p-column-header-content {
      display: flex;
      align-items: center;

      .p-column-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .c-name {
      min-width: 26% !important;
      width: 26%;
      max-width: 400px;
    }

    .c-acc-type {
      width: 15%;
    }

    .p-treetable-thead > tr > th {
      border: none;
      color: ${({ theme }) => theme.colors.prussianBlue};
      border-top: 1px solid ${({ theme }) => theme.colors.stroke};
      padding: 0 8px 0 6px;
      height: 40px;
      font-size: 14px;
      font-weight: 600;
      user-select: none;
      text-align: left;
      margin: 0;
    }
    .p-treetable-thead > tr > th:first-child {
      padding: 0 8px 0 12px;
    }

    .p-treetable-tbody > tr {
      color: ${({ theme }) => theme.colors.prussianBlue};
      border-top: 1px solid ${({ theme }) => theme.colors.stroke};
      font-size: 13px;
      font-weight: 500;
      height: 48px;
      cursor: pointer;

      &:hover {
        background: ${({ theme }) => theme.colors.white};
      }

      &.selected-row {
        background-color: ${({ theme }) => theme.colors.aliceBlue} !important;
      }

      &.disabled-row {
        cursor: default;
        color: ${({ theme }) => theme.colors.cflowerBlue};
      }

      &.child-row-highlight {
        background-color: ${({ theme }) => theme.colors.childRowHighlight};

        &:hover {
          background: ${({ theme }) => theme.colors.white};
        }
      }

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      > td:first-child {
        padding: 0 8px 0 12px;
      }
      > td {
        padding: 0 8px 0 6px;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .p-treetable-toggler {
      width: 1.8rem;
      height: 1.8rem;
      margin-right: 0.4rem;
      color: ${({ theme }) => theme.colors.prussianBlue};
      cursor: pointer;
      z-index: 1;
    }

    ${treeTogglerCaret(5, 9)}
  }

  .c-hidden {
    display: none !important;
  }

  .c-tdm {
    width: 40px !important;
    position: relative;
  }

  .p-treetable-thead > tr > th.c-tdm {
    padding: 0 8px !important;
    text-align: center;

    .p-column-header-content {
      justify-content: center;
    }
  }

  .c-column-select {
    width: 60px !important;
    position: sticky !important;
    right: 0 !important;
    z-index: 2;
  }

  .p-treetable-thead > tr > th.c-column-select {
    z-index: 4;
    padding: 0 16px 0 0 !important;
  }

  .p-treetable-tbody > tr > td.c-column-select {
    padding: 0 16px 0 0 !important;
  }

  .p-treetable-tbody > tr:hover > td.c-column-select {
    background-color: ${({ theme }) => theme.colors.cultured};
  }
`;

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;

  > span:first-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1;
    font-size: 14px;
  }

  > div:last-child {
    flex-shrink: 0;
    margin-left: 6px;
  }
`;
